import { DynamicGalleryRepository } from '@aipb/gulliver/dynamic-gallery/data-access';
import {
  Breadcrumb,
  Pagination,
  PaginationLink,
  RecordContent,
  RecordViewMode
} from '@aipb/gulliver/dynamic-gallery/model';
import { DynamicGalleryRouting } from '@aipb/gulliver/dynamic-gallery/routing';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

@Component({
  selector: 'dg-record',
  templateUrl: './record.component.html',
  styleUrls: ['./record.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecordComponent {
  @Input() collectionLabel: string;
  @Input() items: RecordContent[] = [];
  @Input() breadcrumbs: Breadcrumb[] = [];
  @Input() pagination: Pagination;
  private dynamicGalleryRepository = inject(DynamicGalleryRepository);
  viewMode$ = this.dynamicGalleryRepository.recordViewMode$;
  activeRecordId$ = this.dynamicGalleryRepository.activeRecordId$;

  constructor(private dynamicGalleryRouting: DynamicGalleryRouting) {}

  onBreadcrumb(breadcrumb: Breadcrumb) {
    this.dynamicGalleryRouting.default(breadcrumb.url);
  }

  onPaginationLink(link: PaginationLink) {
    this.dynamicGalleryRouting.default(link.url);
  }

  onChangeRecordViewMode(value: RecordViewMode) {
    this.dynamicGalleryRepository.setRecordViewMode(value);
  }
}
